import { Validators } from "@angular/forms";
import { LayerType, sharedForms } from "../layer.model";
import { ContourProperties, FormType, Properties } from "../properties.model";

export const contourForm: Properties = {
  propertyType: LayerType.Contour,
  label: 'Contour Lines',
  info: "Lines may appear slightly blurry or transparent due to scaling effects. Export your render for an accurate preview of how the lines will appear.",
  forms:
    sharedForms.concat([
    {
      id: ContourProperties.ContourTotalLines,
      label: 'Total Lines',
      type: FormType.SliderNumber,
      defaultValue: 5,
      sliderOptions: {
        min: 1,
        max: 100,
        step: 1
     },
     validators: [Validators.required],
    },
    {
      id: ContourProperties.ContourVisibleRange,
      label: 'Visible Range',

      hint: "Control the vertical range which contour lines appear. Markers represent the highest and lowest points on your map.",
      type: FormType.RangeSlider,
      defaultValue: [0, 255],
      sliderOptions: {
        min: 0,
        max: 255,
        step: 1
      },
    },
    {
      id: ContourProperties.ContourResolution,

      hint: "Modify the roughness of the lines. Higher values yield blocky contour lines.",
      label: 'Roughness',
      type: FormType.SliderNumber,
      defaultValue: 2,
      sliderOptions: {
        min: 1,
        max: 50,
        step: 1
      },
    },
    {
      id: ContourProperties.ContourLineColor,
      label: 'Line Color Gradient',
      type: FormType.Gradient,
      placeholder: "#Hex Color",
      defaultValue: '#FFFFFF',
      validators: [Validators.required, Validators.min(1)],
    },
    {
      id: ContourProperties.ContourLineWidth,
      label: 'Line Width',
      type: FormType.SliderNumber,
      defaultValue: 2,
      sliderOptions: {
        min: 1,
        max: 10,
        step: 1
      },
    },
  ]),
  changeHandler: () => {}
}
